<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      scrollable
      style="background-color: #red"
    >
      <v-container fluid class="full-height">
        <v-row style="background-color: #ceefed">
          <v-col>
            <v-card style="min-height: 100vh" class="card-detail ml-1">
              <v-card-text>
                <v-btn
                  v-if="checkRole == 'แพทย์'"
                  icon
                  large
                  elevation="2"
                  @click="back"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn v-else icon large elevation="2" @click="backCon">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <iframe
                  class="iframe"
                  allow="camera *; microphone; display-capture"
                  frameBorder="0"
                  :src="detailConference.conference_url"
                  scrolling="no"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="4"
            v-show="checkRole == 'แพทย์'"
            v-if="checkRole == 'แพทย์'"
          >
            <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
              <v-tabs
                color="#00a99d"
                class="elevation-0"
                v-model="currentItem"
                show-arrows
                grow
                center-active
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab class="tab pb-2" :value="1"> ข้อมูลการซักประวัติ </v-tab>
                <v-tab class="tab pb-2" :value="0"> บันทึกการรักษา </v-tab>
              </v-tabs>
              <div class="my-4">
                <v-tabs-items v-model="currentItem" class="full-height-tab">
                  <v-tab-item eager
                    ><v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >ข้อมูลการซักประวัติ</span
                        >
                      </div>
                      <v-row
                        class="pa-0 ma-0"
                        v-if="itemHistoryTaking !== null"
                      >
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการสำคัญ </span>
                            <v-text-field
                              solo
                              hide-details="auto"
                              dense
                              readonly
                              :value="
                                itemHistoryTaking.marjor_symptoms
                                  ? itemHistoryTaking.marjor_symptoms
                                  : '-'
                              "
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการปัจจุบัน </span>
                            <v-text-field
                              solo
                              hide-details="auto"
                              dense
                              readonly
                              :value="
                                itemHistoryTaking.current_symptoms
                                  ? itemHistoryTaking.current_symptoms
                                  : '-'
                              "
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> โรคประจำตัว </span>
                            <v-text-field
                              solo
                              hide-details="auto"
                              dense
                              readonly
                              :value="
                                itemHistoryTaking.congenital_disease
                                  ? itemHistoryTaking.congenital_disease
                                  : '-'
                              "
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              บันทึกทางการแพทย์
                            </span>
                            <v-textarea
                              auto-grow
                              solo
                              dense
                              hide-details="auto"
                              readonly
                              :value="
                                itemHistoryTaking.medical_record
                                  ? itemHistoryTaking.medical_record
                                  : '-'
                              "
                            ></v-textarea>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="pa-3 ma-0" v-else
                        ><v-col
                          cols="12"
                          class="noitems d-flex justify-center align-center"
                        >
                          <h2>ไม่มีข้อมูลการซักประวัติ</h2>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item eager
                    ><v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >บันทึกการรักษา</span
                        >
                      </div>

                      <v-row class="pa-0 ma-0">
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการสำคัญ </span>
                            <v-text-field
                              v-model="marjor_symptoms"
                              solo
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการปัจจุบัน </span>
                            <v-text-field
                              solo
                              v-model="current_symptoms"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> โรคประจำตัว </span>
                            <v-text-field
                              solo
                              v-model="congenital_disease"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              บันทึกทางการแพทย์
                            </span>
                            <v-textarea
                              auto-grow
                              v-model="medical_record"
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกข้อมูล"
                            ></v-textarea>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="back"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn width="30%" dark color="#00a99d" @click="save"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tabs-items>
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="4"
            v-show="checkRole == 'เจ้าหน้าที่' || checkRole == 'พยาบาล'"
            v-if="checkRole == 'เจ้าหน้าที่' || checkRole == 'พยาบาล'"
          >
            <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
              <v-tabs
                color="#00a99d"
                class="elevation-0"
                v-model="currentItem"
                show-arrows
                grow
                center-active
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab class="tab pb-2"> ซักประวัติ </v-tab>
              </v-tabs>
              <div class="my-4">
                <v-tabs-items v-model="currentItem" class="full-height-tab">
                  <v-tab-item eager
                    ><v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >ซักประวัติ</span
                        >
                      </div>

                      <v-row class="pa-0 ma-0">
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการสำคัญ </span>
                            <v-text-field
                              v-model="marjor_symptoms"
                              solo
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการปัจจุบัน </span>
                            <v-text-field
                              solo
                              v-model="current_symptoms"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> โรคประจำตัว </span>
                            <v-text-field
                              solo
                              v-model="congenital_disease"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              บันทึกทางการแพทย์
                            </span>
                            <v-textarea
                              auto-grow
                              v-model="medical_record"
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกข้อมูล"
                            ></v-textarea>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="backCon"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="HistoryTaking"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tabs-items>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// import Swal from "sweetalert2";
export default {
  data: () => ({
    // tab: ["บันทึกการรักษา", "บันทึกสุขภาพ"],
    channel_name: "",
    close: false,
    teb: 2,
    itemHistory: [],
    currentItem: 0,
    selectDrug: true,
    dialog: false,
    marjor_symptoms: "",
    current_symptoms: "",
    congenital_disease: "",
    medical_record: "",
    show: false,
    take_drug: true,
    itemSearchDrug: [],
  }),
  watch: {},

  computed: {
    ...mapState(["detailConference", "queue", "itemHistoryTaking"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    checkRole() {
      return sessionStorage.role_name;
    },
  },

  methods: {
    openDialog() {
      this.dialog = true;
      // this.CheckTimeConference();
      setTimeout(() => {
        const params = new URLSearchParams();
        params.append("conference_url", this.detailConference.conference_url);
        // console.log("🚀 ~ CheckTimeConference ~ params:", params);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/get_history_conference`,
            {
              params,
            }
          )
          .then((res) => {
            // console.log("res", res);
            this.channel_name = res.data.data.data.data[0].channel_name;
            console.log("🚀 ~ .then ~ this.channel_name:", this.channel_name);
          });
      }, 10 * 1000);
    },
    ...mapMutations(["setDetailConference"]),
    async HistoryTaking() {
      const {
        congenital_disease,
        current_symptoms,
        marjor_symptoms,
        medical_record,
      } = this;
      const payload = {
        congenital_disease,
        current_symptoms,
        marjor_symptoms,
        medical_record,
        appointment_id: this.queue.appointment_id,
        take_drug: false,
        patient_name: this.queue.patient_name,
        biz_id: sessionStorage.biz_id,
        conference_id: this.detailConference._id,
        nurse_id: this.queue.doctor_id,
        nurse_name: this.queue.doctor_name,
      };
      const { data: { result } = {} } = await this.axios.post(
        `${process.env.VUE_APP_BACKEND_URL}/v1/historyTaking`,
        payload
      );
      if (result == "success") {
        this.$swal.fire({
          icon: "success",
          title: "บันทึกการรักษาสำเร็จ",
          showConfirmButton: false,
          timer: 1000,
        });
        this.close = true;
        this.endConference();
        // this.CheckTimeConference();
        this.Clear();
        this.dialog = false;
        this.$emit("success_con");
      }
    },
    async save() {
      const {
        congenital_disease,
        current_symptoms,
        marjor_symptoms,
        medical_record,
      } = this;
      let drug_list = [];
      const payload = {
        congenital_disease,
        current_symptoms,
        marjor_symptoms,
        medical_record,
        appointment_id: this.queue.appointment_id,
        take_drug: false,
        drug_list,
        patient_name: this.queue.patient_name,
        biz_id: sessionStorage.biz_id,
        conference_id: this.detailConference._id,
        doctor_id: this.queue.doctor_id,
        doctor_name: this.queue.doctor_name,
      };
      const { data: { result } = {} } = await this.axios.post(
        `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-appointment`,
        payload
      );
      if (result == "success") {
        this.$swal.fire({
          icon: "success",
          title: "บันทึกการรักษาสำเร็จ",
          showConfirmButton: false,
          timer: 1000,
        });
        if (drug_list.length > 0) {
          this.close = true;
          this.endConference();
          // this.CheckTimeConference();
          this.dialog = false;
          this.$emit("success_drug");
        } else {
          this.close = true;
          this.endConference();
          // this.CheckTimeConference();
          this.dialog = false;
          this.$emit("success");
        }
      }
    },
    // async CheckTimeConference() {
    //   try {
    //     await setTimeout(() => {
    //       if (this.close == false) {
    //         console.log("🚀 ~ awaitsetTimeout ~ this.close:", this.close);
    //         Swal.fire({
    //           toast: true,
    //           html: `<div style='display: flex; align-items: center;'><img src='${require("@/assets/icon/weather_Y.png")}' alt='Icon' style='max-width: 50%; max-height: 50px; margin-bottom: 10px;'> <span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'> เหลือเวลา Conference อีก 5 นาที</span> </div>`,
    //           animation: false,
    //           position: "bottom",
    //           showConfirmButton: false,
    //           timer: 5000,
    //           timerProgressBar: true,
    //           didOpen: (toast) => {
    //             toast.addEventListener("mouseenter", Swal.stopTimer);
    //             toast.addEventListener("mouseleave", Swal.resumeTimer);
    //           },
    //         });
    //       }
    //     }, 300 * 1000); /// 300*1000 5นาที
    //     await setTimeout(() => {
    //       if (this.close == false) {
    //         console.log("🚀 ~ awaitsetTimeout ~ this.close:", this.close);
    //         Swal.fire({
    //           toast: true,
    //           html: `<div style='display: flex; align-items: center;'><img src='${require("@/assets/icon/weather_Y.png")}' alt='Icon' style='max-width: 50%; max-height: 50px; margin-bottom: 10px;'> <span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'> เหลือเวลา Conference อีก 1 นาที</span> </div>`,
    //           animation: false,
    //           position: "bottom",
    //           showConfirmButton: false,
    //           timer: 5000,
    //           timerProgressBar: true,
    //           didOpen: (toast) => {
    //             toast.addEventListener("mouseenter", Swal.stopTimer);
    //             toast.addEventListener("mouseleave", Swal.resumeTimer);
    //           },
    //         });
    //       }
    //     }, 540 * 1000); /// 540*1000 9นาที
    //     await setTimeout(async () => {
    //       if (this.close == false) {
    //         console.log("🚀 ~ awaitsetTimeout ~ this.close:", this.close);
    //         // Swal.fire({
    //         //   toast: true,
    //         //   html: `<div style='display: flex; align-items: center;'><img src='${require("@/assets/icon/weather_Y.png")}' alt='Icon' style='max-width: 50%; max-height: 50px; margin-bottom: 10px;'> <span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'> สิ้นสุดการ Conference</span> </div>`,
    //         //   animation: false,
    //         //   position: "bottom",
    //         //   showConfirmButton: false,
    //         //   timer: 5000,
    //         //   timerProgressBar: true,
    //         //   didOpen: (toast) => {
    //         //     toast.addEventListener("mouseenter", Swal.stopTimer);
    //         //     toast.addEventListener("mouseleave", Swal.resumeTimer);
    //         //   },
    //         // });
    //         var body = {
    //           channel_name: this.channel_name,
    //         };
    //         await this.axios
    //           .post(`https://meet.manageai.co.th/api/v1/calling/ending`, body)
    //           .then((res) => {
    //             console.log("🚀 ~ .then ~ res:", res);
    //           });
    //       }
    //     }, 600 * 1000); /// 600*1000 10นาที
    //   } catch (error) {
    //     console.error();
    //   }
    // },
    endConference() {
      try {
        var body = {
          channel_name: this.channel_name,
        };
        this.axios
          .post(`https://meet.manageai.co.th/api/v1/calling/ending`, body)
          .then((res) => {
            console.log("🚀 ~ .then ~ res:", res);
          });
      } catch (error) {
        console.error();
      }
    },
    Clear() {
      this.congenital_disease = "";
      this.current_symptoms = "";
      this.marjor_symptoms = "";
      this.medical_record = "";
    },
    getChoose(choose) {
      this.selectDrug = choose;
    },
    back() {
      this.close = true;
      this.endConference();
      // this.CheckTimeConference();
      this.Clear();
      this.dialog = false;
      this.$emit("back");
    },
    backCon() {
      this.close = true;
      this.endConference();
      // this.CheckTimeConference();
      this.Clear();
      this.dialog = false;
      this.$emit("back_con");
    },
  },
};
</script>
<style scoped>
.card-detail {
  border-radius: 20px;
}
.v-tabs-items.full-height-tab .v-window-item {
  height: calc(85vh); /* Adjust 270px to suits your needs */
  overflow-y: auto;
}
.iframe {
  width: 100%;
  height: 90vh;
}
.noitems {
  height: 77vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}
.usageAndAdvice {
  border: 1px solid #00000061;
  border-radius: 4px;
  margin: 0px;
}
@media only screen and (max-width: 1264px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 960px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 360px) {
  .iframe {
    width: 100%;
    height: 30vh;
  }
}
</style>
